export default {
    manageAttendance: 'จัดการสถานะ',
    searchByEmployeeName: 'ค้นหาจากชื่อ, รหัสพนักงาน, สำนักงาน',
    search: 'ค้นหา',
    employeeId: 'รหัสพนักงาน',
    employeeName: 'ชื่อ - นามสกุล',
    bureau: 'สำนักงาน',
    date: 'วันที่',
    checkIn: 'เวลาเข้า',
    status: 'สถานะ',
    action: '',
    congratulation: 'ยินดีด้วย',
    somethingWrong: 'เกิดข้อผิดพลาด'
}
